/** Red badge styling for Forms inbox counts — nav rail + Forms sidebar sections. */
export const FORMS_INBOX_BADGE_RED = '#dc2626';
